import { createContext } from 'react';

export interface RouterContextState {
  currentState: any;
}

export default createContext<RouterContextState>({
  currentState: undefined,
});
